import { ErrorCodeEnum } from '@/config';
import { useState } from 'react';
import { parseError } from '@/redux/helpers';

const useApiCall = (apiRequest: (params?: any) => void) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState<ErrorCodeEnum | null>(null);

  const apiCall = async function (...args: any[]) {
    try {
      setErrorCode(null);
      setIsLoading(true);
      setError(() => '');
      await apiRequest(...args);
    } catch (mistake: unknown) {
      const { message, errorCode: code } = parseError(mistake);
      setError(() => message);
      setErrorCode(() => code);
    } finally {
      setIsLoading(false);
    }
  };

  return [apiCall, isLoading, error, errorCode] as const;
};

export default useApiCall;
